// 업적 갤러리 훅 — /collection 화면과 MY '황소 컬렉션' 카드가 같은 캐시를 공유한다 (2026-09-12)
import { useQuery } from "@tanstack/react-query";
import { buildAchievementGallery, type AchievementGallery } from "@core/economy/achievementGallery";
import { fetchAchievementGalleryRows } from "../data-access/achievementsSupabase";
import { useAuth } from "../lib/useAuth";

export function useAchievementGallery() {
  const { user, loading: authLoading } = useAuth();
  const userId = user?.id ?? null;
  const query = useQuery<AchievementGallery>({
    // 계정별 키 — 로그아웃·계정 전환 시 다른 사람의 획득 기록이 섞이지 않게
    queryKey: ["achievementGallery", userId],
    queryFn: async () => {
      const { defs, unlocked } = await fetchAchievementGalleryRows(userId);
      return buildAchievementGallery(defs, unlocked);
    },
    // 세션 복원 전에는 미로그인으로 오판해 "전부 잠김"을 잠깐 그리지 않도록 기다린다
    enabled: !authLoading,
    // 업적 토스트를 누르고 들어오면 방금 딴 업적이 보여야 한다 → 마운트마다 재조회(캐시는 즉시 표시)
    staleTime: 0,
  });
  return { ...query, loggedIn: !!user, authLoading };
}
